import { api } from "api/api";
import { AxiosError } from "axios";
import IndicadorDashboard from "model/indicadores/IndicadorDashboard";

class IndicadorDashboardService {

    dados(idIndicador: number, dataFilter: { inicio: Date | null; fim: Date | null; }) {
        console.log(dataFilter)
        return new Promise<IndicadorDashboard>((resolve, reject): void => {
            let filters = "";
            if (dataFilter.inicio || dataFilter.fim) {
                filters = "?filters=";
                filters += encodeURIComponent("{");
                filters += encodeURIComponent(`"data":{${Object.keys(dataFilter).map((valueKey) => `"${valueKey}":${JSON.stringify((dataFilter as any)[valueKey])}`).join(',')}}`);
                filters += encodeURIComponent("}");
            }
            let url = `/indicador/dashboard/tabela/${idIndicador}${filters}`;
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
}

export default IndicadorDashboardService;